<template>
  <div class="ax-skeleton">
    <div class="type-name"></div>
    <div class="cell-content">
      <h6></h6>
      <p></p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.approve-content .ax-skeleton {
  display: flex;
  padding: 20px;
  position: relative;
  &:after {
    position: absolute;
    left: 76px;
    right: 20px;
    bottom: 0;
    content: ' ';
    box-sizing: border-box;
    border-bottom: 1px solid $border-color;
    transform: scaleY(0.5);
  }
  .type-name {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #f2f3f5;
    margin-right: 10px;
  }
  .cell-content {
    flex: 1;
    h6 {
      height: 20px;
      background-color: #f2f3f5;
      width: 80%;
      margin-bottom: 6px;
    }
    p {
      background-color: #f2f3f5;
      height: 14px;
      width: 50%;
    }
  }
}
</style>
